/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import BaseCom from "../BaseCom";
import Card from "../Card";
import FormLabel from "../FormLabel";
import L from "../Lang";

export default class SpecimenSummary extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return <>
            <Card>
                <div className="row">
                    <div className="col-md-6">
                        <FormLabel model={this.props.specimen?.sid} label="Specimen ID" />
                        <FormLabel model={this.props.specimen?.accountName} label="Account" />
                        <FormLabel model={this.props.specimen?.providerName} label="Provider" />
                        <FormLabel model={this.props.order?.patient?.name} label="Patient" />
                        <FormLabel model={this.props.order?.patient?.genderLong} label="Patient Gender" />
                        <FormLabel model={this.props.specimen?.status} label="Status" />
                        <div className="mb-3">
                            <div className="c-formlabel">
                                <h5><L>Panels</L></h5>
                            </div>
                            <ul className="list-group">
                                {this.props.specimen?.panels?.map((i, idx) => <div key={idx} className="list-group-item">{i.name} ({i.code})</div>)}
                            </ul>
                        </div>
                    </div>
                </div>
            </Card>
        </>;
    }
}
